var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiBadge from '@material-ui/core/Badge';
/**
 * Kareo wrapped component of the Material-UI Badge. The prop API has been limited to props defined in BadgeProps.
 *
 * Badge generates a small badge to the top-right of its children.
 *
 * Material-UI Badge: [Docs](https://v4.mui.com/components/badges), [API](https://v4.mui.com/api/badge)
 *
 * @storybook: [Badge](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-badge--badge-example)
 */
var Badge = React.forwardRef(function (props, ref) { return (React.createElement(MuiBadge, __assign({}, props, { ref: ref, color: "secondary" }))); });
Badge.displayName = 'KareoBadge';
export default Badge;
